import config, { Country } from '../config';
import { escapeString } from './format-text';
import i18n from './i18n';

const yagaTitle = config.get('name');

function getRootCategoryName(categories) {
  if (categories?.length > 0) {
    return categories[0]?.title;
  }

  return '';
}

export function getCategorySEOFriendlyTitle(category) {
  const categoryName = category?.name ? category?.name : '';
  const titleArray = [categoryName];

  return generateTitleFromData(titleArray);
}

export function getProductSEOFriendlyTitle(product) {
  const category = getRootCategoryName(product?.categories || []);
  const description = product?.description ? escapeString(product?.description).slice(0, 39) : '';
  const titleArray = [category, description];

  return generateTitleFromData(titleArray);
}

export function getShopSEOFriendlyTitle(shop) {
  const shopName = shop?.name ? shop?.name : '';
  const titleArray = [shopName];

  return generateTitleFromData(titleArray);
}

export function getSEOFriendlyTitle(data) {
  const titleArray = [...data];

  return generateTitleFromData(titleArray);
}

function generateTitleFromData(data) {
  const titleArray = [...data, yagaTitle];
  const filteredTitleArray = titleArray.filter((item) => item);
  const titleString = filteredTitleArray.join(' | ');
  const defaultTitle = `${i18n.t('meta.title')} | ${yagaTitle}`;

  return filteredTitleArray.length > 1 ? titleString : defaultTitle;
}

export function getJsonLdBreadcrumbsList(router, productInfo = null) {
  if (!router?.asPath) {
    return [];
  }

  const { asPath } = router;
  let jsonLdBreadcrumbsList = [];
  const excludedPaths = [
    '',
    '_next',
    'data',
    'development',
    'build',
    'search',
    'otsi',
    'minu',
    'my',
    'toode',
    'product',
    'tooted',
    'products',
    'kategooria',
    'category',
  ];

  const country = config.get('country');
  const host = config.get('web.meta.url')[country];
  const linkPath = asPath.split('/');

  linkPath.shift();

  const homeBreadcrumb = {
    position: 1,
    name: i18n.t('common.main-page'),
    item: host,
  };
  const startPosition = 2;
  const pathArray = linkPath
    .map((path, index) => {
      if (!excludedPaths.includes(path)) {
        const position = startPosition + index - 1;
        const positionToUse = position < startPosition ? startPosition : position;

        return generateBreadcrumbObject(path, index, linkPath, positionToUse, productInfo, country);
      }

      return false;
    })
    .filter((path) => path);

  pathArray.unshift(homeBreadcrumb);
  jsonLdBreadcrumbsList = pathArray;

  return jsonLdBreadcrumbsList;
}

function generateBreadcrumbObject(path, index, source, position, productInfo, country: Country) {
  let name = path.charAt(0).toUpperCase() + path.slice(1);

  if (productInfo?.productSlug === path) {
    name = productInfo?.name;
  }

  // Remove query/filter params from name
  if (name.includes('?')) {
    name = name.split('?')[0];
  }

  const host = config.get('web.meta.url')[country];

  const item = `${host}/${source.slice(0, index + 1).join('/')}`;

  return { position, name, item };
}
